import { __decorate, __param } from 'tslib';
import { Directive, ChangeDetectorRef, Inject, ViewChild, Input, ContentChild, TemplateRef, HostBinding, HostListener, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { isCurrentTarget, tuiDefaultProp, tuiRequiredSetter } from '@taiga-ui/cdk';
import { TUI_EXPAND_LOADED } from '@taiga-ui/core/constants';
import { CommonModule } from '@angular/common';
import { TuiLoaderModule } from '@taiga-ui/core/components/loader';

// @bad TODO Replace with PolymorpheusContent
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@taiga-ui/core/components/loader';

const _c0 = ["wrapper"];
function TuiExpandComponent_ng_container_2_tui_loader_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function TuiExpandComponent_ng_container_2_tui_loader_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tui-loader", 4);
    ɵngcc0.ɵɵtemplate(1, TuiExpandComponent_ng_container_2_tui_loader_2_ng_container_1_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("overlay", true)("showLoader", ctx_r2.loading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.content);
} }
function TuiExpandComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵtemplate(2, TuiExpandComponent_ng_container_2_tui_loader_2_Template, 2, 3, "tui-loader", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.async)("ngIfElse", ctx_r1.content);
} }
const _c1 = ["*"];
let TuiExpandContentDirective = class TuiExpandContentDirective {
};
TuiExpandContentDirective.ɵfac = function TuiExpandContentDirective_Factory(t) { return new (t || TuiExpandContentDirective)(); };
TuiExpandContentDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TuiExpandContentDirective, selectors: [["", "tuiExpandContent", ""]] });

var State;
(function (State) {
    State[State["Idle"] = 0] = "Idle";
    State[State["Loading"] = 1] = "Loading";
    State[State["Prepared"] = 2] = "Prepared";
    State[State["Animated"] = 3] = "Animated";
})(State || (State = {}));
const LOADER_HEIGHT = 48;
let TuiExpandComponent = class TuiExpandComponent {
    constructor(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this.state = State.Idle;
        this.async = false;
        this.expanded = null;
    }
    set expandedSetter(expanded) {
        if (this.expanded === null) {
            this.expanded = expanded;
            return;
        }
        if (this.state !== State.Idle) {
            this.expanded = expanded;
            this.state = State.Animated;
            return;
        }
        this.expanded = expanded;
        this.retrigger(this.async && expanded ? State.Loading : State.Animated);
    }
    get overflow() {
        return this.state !== State.Idle;
    }
    get loading() {
        return !!this.expanded && this.async && this.state === State.Loading;
    }
    get height() {
        const { expanded, state, contentWrapper } = this;
        if ((expanded && state === State.Prepared) ||
            (!expanded && state === State.Animated)) {
            return 0;
        }
        if (contentWrapper &&
            ((!expanded && state === State.Prepared) ||
                (expanded && state === State.Animated))) {
            return contentWrapper.nativeElement.offsetHeight;
        }
        if (contentWrapper && expanded && state === State.Loading) {
            return Math.max(contentWrapper.nativeElement.offsetHeight, LOADER_HEIGHT);
        }
        return null;
    }
    get contentVisible() {
        return this.expanded || this.state !== State.Idle;
    }
    onTransitionEnd(event) {
        if (isCurrentTarget(event) &&
            event.propertyName === 'opacity' &&
            this.state === State.Animated) {
            this.state = State.Idle;
        }
    }
    onExpandLoaded(event) {
        event.stopPropagation();
        if (this.state === State.Loading) {
            this.retrigger(State.Animated);
        }
    }
    retrigger(state) {
        this.state = State.Prepared;
        // We need delay to retrigger CSS height transition from the correct number
        setTimeout(() => {
            if (this.state !== State.Prepared) {
                return;
            }
            this.state = state;
            this.changeDetectorRef.markForCheck();
        });
    }
};
TuiExpandComponent.ɵfac = function TuiExpandComponent_Factory(t) { return new (t || TuiExpandComponent)(ɵngcc0.ɵɵdirectiveInject(ChangeDetectorRef)); };
TuiExpandComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TuiExpandComponent, selectors: [["tui-expand"]], contentQueries: function TuiExpandComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TuiExpandContentDirective, true, TemplateRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.content = _t.first);
    } }, viewQuery: function TuiExpandComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contentWrapper = _t.first);
    } }, hostVars: 9, hostBindings: function TuiExpandComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("transitionend", function TuiExpandComponent_transitionend_HostBindingHandler($event) { return ctx.onTransitionEnd($event); })("tui-expand-loaded", function TuiExpandComponent_tui_expand_loaded_HostBindingHandler($event) { return ctx.onExpandLoaded($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-expanded", ctx.expanded);
        ɵngcc0.ɵɵstyleProp("height", ctx.height, "px");
        ɵngcc0.ɵɵclassProp("_expanded", ctx.expanded)("_overflow", ctx.overflow)("_loading", ctx.loading);
    } }, inputs: { async: "async", expandedSetter: ["expanded", "expandedSetter"] }, ngContentSelectors: _c1, decls: 3, vars: 1, consts: [[1, "wrapper"], ["wrapper", ""], [4, "ngIf"], ["size", "l", 3, "overlay", "showLoader", 4, "ngIf", "ngIfElse"], ["size", "l", 3, "overlay", "showLoader"], [4, "ngTemplateOutlet"]], template: function TuiExpandComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵtemplate(2, TuiExpandComponent_ng_container_2_Template, 3, 2, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.contentVisible);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.TuiLoaderComponent, ɵngcc1.NgTemplateOutlet], styles: ["[_nghost-%COMP%]{display:block;transition-property:opacity,height,visibility;transition-duration:var(--tui-duration,300ms);opacity:0}._overflow[_nghost-%COMP%]{overflow:hidden}._expanded[_nghost-%COMP%]{opacity:1;transform:translate3d(0,0,0)}._loading[_nghost-%COMP%]{opacity:.99}.wrapper[_ngcontent-%COMP%]:after, .wrapper[_ngcontent-%COMP%]:before{content:'';display:table}"], changeDetection: 0 });
TuiExpandComponent.ctorParameters = () => [
    { type: ChangeDetectorRef, decorators: [{ type: Inject, args: [ChangeDetectorRef,] }] }
];
__decorate([
    ViewChild('wrapper')
], TuiExpandComponent.prototype, "contentWrapper", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiExpandComponent.prototype, "async", void 0);
__decorate([
    Input('expanded'),
    tuiRequiredSetter()
], TuiExpandComponent.prototype, "expandedSetter", null);
__decorate([
    ContentChild(TuiExpandContentDirective, { read: TemplateRef })
], TuiExpandComponent.prototype, "content", void 0);
__decorate([
    HostBinding('class._expanded'),
    HostBinding('attr.aria-expanded')
], TuiExpandComponent.prototype, "expanded", void 0);
__decorate([
    HostBinding('class._overflow')
], TuiExpandComponent.prototype, "overflow", null);
__decorate([
    HostBinding('class._loading')
], TuiExpandComponent.prototype, "loading", null);
__decorate([
    HostBinding('style.height.px')
], TuiExpandComponent.prototype, "height", null);
__decorate([
    HostListener('transitionend', ['$event'])
], TuiExpandComponent.prototype, "onTransitionEnd", null);
__decorate([
    HostListener(TUI_EXPAND_LOADED, ['$event'])
], TuiExpandComponent.prototype, "onExpandLoaded", null);
TuiExpandComponent = __decorate([ __param(0, Inject(ChangeDetectorRef))
], TuiExpandComponent);

let TuiExpandModule = class TuiExpandModule {
};
TuiExpandModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TuiExpandModule });
TuiExpandModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TuiExpandModule_Factory(t) { return new (t || TuiExpandModule)(); }, imports: [[CommonModule, TuiLoaderModule]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiExpandContentDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiExpandContent]'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiExpandComponent, [{
        type: Component,
        args: [{
                selector: 'tui-expand',
                template: "<div #wrapper class=\"wrapper\">\n    <ng-container *ngIf=\"contentVisible\">\n        <ng-content></ng-content>\n        <tui-loader\n            *ngIf=\"async; else content\"\n            size=\"l\"\n            [overlay]=\"true\"\n            [showLoader]=\"loading\"\n        >\n            <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n        </tui-loader>\n    </ng-container>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{display:block;transition-property:opacity,height,visibility;transition-duration:var(--tui-duration,300ms);opacity:0}:host._overflow{overflow:hidden}:host._expanded{opacity:1;transform:translate3d(0,0,0)}:host._loading{opacity:.99}.wrapper:after,.wrapper:before{content:'';display:table}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef, decorators: [{
                type: Inject,
                args: [ChangeDetectorRef]
            }] }]; }, { async: [{
            type: Input
        }], expanded: [{
            type: HostBinding,
            args: ['class._expanded']
        }, {
            type: HostBinding,
            args: ['attr.aria-expanded']
        }], expandedSetter: [{
            type: Input,
            args: ['expanded']
        }], overflow: [{
            type: HostBinding,
            args: ['class._overflow']
        }], loading: [{
            type: HostBinding,
            args: ['class._loading']
        }], height: [{
            type: HostBinding,
            args: ['style.height.px']
        }], onTransitionEnd: [{
            type: HostListener,
            args: ['transitionend', ['$event']]
        }], onExpandLoaded: [{
            type: HostListener,
            args: [TUI_EXPAND_LOADED, ['$event']]
        }], contentWrapper: [{
            type: ViewChild,
            args: ['wrapper']
        }], content: [{
            type: ContentChild,
            args: [TuiExpandContentDirective, { read: TemplateRef }]
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiExpandModule, { declarations: function () { return [TuiExpandComponent, TuiExpandContentDirective]; }, imports: function () { return [CommonModule, TuiLoaderModule]; }, exports: function () { return [TuiExpandComponent, TuiExpandContentDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiExpandModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, TuiLoaderModule],
                declarations: [TuiExpandComponent, TuiExpandContentDirective],
                exports: [TuiExpandComponent, TuiExpandContentDirective]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiExpandComponent, TuiExpandContentDirective, TuiExpandModule };

//# sourceMappingURL=taiga-ui-core-components-expand.js.map